import "./style.css";

function Login({ emphasis }) {
  return (
    <div id="Login">
      <h1 class="login-quote">Find your</h1>
      <h1 class="login-quote-emphasis login-quote" style={{ fontSize: "2rem" }}>
        {emphasis}
      </h1>
      <Input title="Username" />
      <Input title="Password" />
      {/* <Input title="PasswordVeri" /> */}
      <RememberMe />
      <Button title="UserSub" />
      {/*The button did not need anything in it, hence it is an "empty" html element*/}
      <SignUp />
    </div>
  );
}

function Input(props) {
  return (
    <div className="Input">
      <input placeholder={props.title} className="input-bar" />
    </div>
  );
}

function Button() {
  return (
    <div className="Submission">
      <button id="submit-button">Login</button>
    </div>
  );
}

function RememberMe() {
  return (
    <div id="remember_me">
      <div id="remember_me_inner">
        <input id="remember_me_checkbox" type="checkbox" />
        <a href="" id="remember_me_link">
          Remember me
        </a>
        <a id="forgot_pass_link">Forgot Password</a>
      </div>
    </div>
  );
}
function SignUp() {
  return (
    <div id="sign_up_container">
      <p>Not a member?</p>{" "}
      <a href="" id="forgot_pass_link">
        Sign Up Now
      </a>
    </div>
  );
}
export default Login;
